import CardType from "creditcards-types/type";
import discover from "creditcards-types/types/discover";

// Ref: https://github.com/bendrucker/creditcards-types/blob/v3.3.0/types/discover.js
export default CardType({
  name: discover.name,
  digits: [16, 19],
  pattern: /^6(011|4[4-9]\d{1}|5\d{2})\d{12,15}$/,
  eagerPattern: /^6(011|4[4-9]|5)/,
  groupPattern: /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/,
  luhn: discover.luhn,
});
